export const TOKEN_EXPIRES_KEY = 'tokenExpiresOn';
export const REFRESH_TOKEN_EXPIRES_KEY = 'refreshTokenExpiresOn';
export const REDIRECT_URL_KEY = 'redirectUrl';
export const IMPERSONATION_TOKEN_KEY = 'impersonation_token';
export const PERMANENT_DELETE_CONFIRMATION_TOKEN = 'DELETE';
